import { ISimpleTime, IPunchDocument } from "../models"
import {
	red500, pink500, purple500, deepPurple500, indigo500, blue500, lightBlue500, cyan500,
	teal500, green500, lightGreen500, lime500, yellow500, amber500, orange500, deepOrange500, grey500,
	red900, pink900, purple900, deepPurple900, indigo900, blue900, lightBlue900, cyan900,
	teal900, green900, lightGreen900, lime900, yellow900, amber900, orange900, deepOrange900, grey900
} from "material-ui/styles/colors"
import _ from "lodash"

export function getBiometricScore(punch: IPunchDocument): string {
	const metaData = punch.MetaData
	let score = punch.ImageID ? metaData.BiometricScore > 0.99 ? "98.99%" : `${(metaData.BiometricScore * 100).toFixed(2)}%` : "";
	if (metaData && metaData.BiometricUpgradedScore * 100 > 0) {
		score = metaData.BiometricUpgradedScore > 0.99 ? "98.99%" : `${(metaData.BiometricUpgradedScore * 100).toFixed(0)}%`
	}
	return score as string
}

export function getLivenessScore(punch: IPunchDocument): string {
	const metaData = punch.MetaData
	if (!metaData || !metaData.LivenessScore || metaData.LivenessScore < 0) return "N/A"
	return `${(metaData.LivenessScore * 100).toFixed(2)}%`
}

export function toPercentage(value) {
	if (isNaN(value)) return "—"

	return Math.round(value * 100) + "%"
}

export function guid() {
	function s4() {
		return Math.floor((1 + Math.random()) * 0x10000)
			.toString(16)
			.substring(1)
	}
	return s4() + s4() + "-" + s4() + "-" + s4() + "-" + s4() + "-" + s4() + s4() + s4()
}

export function getCookie(cname) {
	const getKey = "findd_" + cname
	return localStorage.getItem(getKey) ? localStorage.getItem(getKey) : ""
}

export function getNonLocalStorageCookie(cname) {
	var name = cname + "="
	var decodedCookie = decodeURIComponent(document.cookie)
	var ca = decodedCookie.split(';')
	for (var i = 0; i < ca.length; i++) {
		var c = ca[i];
		while (c.charAt(0) == ' ') {
			c = c.substring(1)
		}
		if (c.indexOf(name) == 0) {
			return c.substring(name.length, c.length)
		}
	}

	return ""
}

export function deleteCookie(name) {
	document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}

export function validateEmail(email) {
	const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
	return re.test(email)
}

export function validatePhone(phone) {
	const re = /^\D?(\d{3})\D?\D?(\d{3})\D?(\d{4})$/
	return re.test(phone)
}

export function escapeDateTime(dateTime) {
	if (dateTime) {
		return dateTime.replace("+", "%2B")
	} else {
		return dateTime
	}
}

export function validateInteger(value) {
	const regexInt = /^([0-9])$/
	let validInt = true
	for (const char of value) {
		if (!regexInt.test(char)) {
			validInt = false
		}
	}
	return validInt
}

export function validateDouble(value) {
	const regexDouble = /^\d*\.?\d*$/
	return regexDouble.test(value)
}

export function roundToTwo(_number: number) {
	return Math.round(_number * 100) / 100
}

export function roundToFive(_number) {
	return Math.round(_number * 100000) / 100000
}

export function checkIsBefore(first: ISimpleTime, second: ISimpleTime) {
	let isBefore = true
	if (first.Hour > second.Hour) {
		isBefore = false
	}
	else if (first.Hour === second.Hour && first.Minute >= second.Minute) {
		isBefore = false
	}
	return isBefore
}

export function getMaterial900ColorFrom500Color(color500) {
	let color900
	switch (color500) {
		case red500:
			color900 = red900
			break
		case pink500:
			color900 = pink900
			break
		case purple500:
			color900 = purple900
			break
		case deepPurple500:
			color900 = deepPurple900
			break
		case indigo500:
			color900 = indigo900
			break
		case blue500:
			color900 = blue900
			break
		case lightBlue500:
			color900 = lightBlue900
			break
		case cyan500:
			color900 = cyan900
			break
		case teal500:
			color900 = teal900
			break
		case green500:
			color900 = green900
			break
		case lightGreen500:
			color900 = lightGreen900
			break
		case lime500:
			color900 = lime900
			break
		case yellow500:
			color900 = yellow900
			break
		case amber500:
			color900 = amber900
			break
		case orange500:
			color900 = orange900
			break
		case deepOrange500:
			color900 = deepOrange900
			break
		case grey500:
			color900 = grey900
	}
	return color900
}

export function checkIEBrowser(): boolean {
	const ua = window.navigator.userAgent //Check the userAgent property of the window.navigator object
	const msie = ua.indexOf('MSIE ') // IE 10 or older
	const trident = ua.indexOf('Trident/') //IE 11
	return (msie > 0 || trident > 0)
}

export function validateIPaddress(ipAddress) {
	return /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(ipAddress)
}

export function getBase64(file: File) {
	return new Promise((resolve, reject) => {
		const reader = new FileReader();
		reader.readAsDataURL(file);
		reader.onload = () => resolve(reader.result);
		reader.onerror = error => reject(error);
	});
}

export function sortAlphabetical(items: any[], sortFieldName: string) {
	return items.sort((a, b) => {
		if (a[sortFieldName] < b[sortFieldName]) return -1
		if (a[sortFieldName] > b[sortFieldName]) return 1
		return 0
	})
}

export function getNumberFromBigNumber(number): number {
	return Number(number.toString())
}

export function convertDefaultDateToNull(dateTime: Date | string) {
	// 0001 is the default Year set by BackEnd
	if ((dateTime as string).includes("0001")) {
		return null
	}
	return dateTime
}

export function getCurrencyFormat(currency: number) {
	return currency.toLocaleString('en-US', { style: 'currency', currency: 'USD' })
}

export function validateImgFileExtension(_file) {
	const fileName = _file.name
	const allowedExtensions = /(\.jpg|\.jpeg|\.png)$/i

	return allowedExtensions.exec(fileName)
}

export function validateUploadFileExtension(_file, onlyPdfImg: boolean, onlyImg: boolean) {
	const fileName = _file.name
	const allowedExtensions = onlyImg ?
		/(\.jpg|\.jpeg|\.png|\.bmp)$/i :
		onlyPdfImg ?
			/(\.pdf|\.png|\.jpg)$/i :
			/(\.jpg|\.jpeg|\.png|\.bmp|\.pdf|\.zip|\.txt|\.html|\.doc|\.docx|\.csv|\.xlsx|\.xls|\.pptx|\.ppt)$/i
	return allowedExtensions.exec(fileName)
}

export function validateFileSize(_file) {
	const maxFileSize = 10 * 1024 * 1024 // 10 MB
	const fileSize = _file.size

	return maxFileSize > fileSize
}

export function isEquivalentObjects(a, b) {
	if ((a === null && b === null)) return true
	if ((a !== null && b === null) || (a === null && b !== null)) return false

	// Create arrays of property names
	const aProps = Object.getOwnPropertyNames(a)
	const bProps = Object.getOwnPropertyNames(b)

	// If number of properties is different, objects are not equivalent
	if (aProps.length != bProps.length) {
		return false
	}

	for (let i = 0; i < aProps.length; i++) {
		let propName = aProps[i]
		// If values of same property are not equal, objects are not equivalent
		if (a[propName] !== b[propName]) {
			return false
		}
	}
	// If we made it this far, objects are considered equivalent
	return true
}

export function getDecimalCount(num: number): number {
	let numStr: string = num.toString()
	return numStr.includes(".") ? numStr.split(".")[1].length : 0
}

export function findCommonDifferentPropertiesInObjects(objects) {
	var common = _.reduce(objects, function (acc, obj) {
		for (var p in obj)
			acc[p] = obj[p]
		return acc
	}, {})
	var different = _.reduce(objects, function (acc, obj) {
		for (var p in common)
			if (common[p] !== obj[p]) {
				delete common[p]
				acc.push(p)
			}
		return acc
	}, [])
	return {
		common: common,
		different: different
	}
}

export function validateEmailListString(emailList: string) {
	var emails = emailList.replace(/\s/g, '').split(",")

	var valid = true
	var regex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

	for (var i = 0; i < emails.length; i++) {
		if (emails[i] == "" || !regex.test(emails[i])) {
			valid = false
		}
	}

	return valid
}

export function replaceFrontEndFormScopeId(scopeId, formString) {
	let returnString = formString.replaceAll("{SCOPEID}", scopeId)

	return returnString
}

export function decimalCount(num: number) {
	const numStr = String(num)
	return numStr.includes('.') ?
		numStr.split('.')[1].length :
		0
}

export function sumOfNumbers(numbers: number[]): number {
	return numbers.reduce((acc, num) => acc + num, 0)
}

export function sumOfNumberValues(arr: any[], propertyName: string): number {
	return arr.reduce((acc, obj) => acc + (obj[propertyName] || 0), 0)
}

export function validateName(name: string): boolean {
	const namePattern = /^[A-Za-z\- .]+$/
	return namePattern.test(name)
}


export function getTrendColorGreen(): string {
	return "#3AAD07"
}

export function getTrendColorGreenGradient1(): string {
	return 'rgba(58, 173, 7,1)'
}

export function getTrendColorGreenGradient2(): string {
	return 'rgba(58, 173, 7, .15)'
}

export function getTrendColorRed(): string {
	return "#F22803"
}

export function getTrendColorRedGradient1(): string {
	return 'rgba(242, 40, 3,1)'
}
export function getTrendColorRedGradient2(): string {
	return 'rgba(242, 40, 3,.15)'
}

export function getTrendColorGrey(): string {
	return "#cccccc"
}

// New color functions for blue, orange, and purple
export function getTrendColorBlue(): string {
	return "#007BFF";
}

export function getTrendColorBlueGradient1(): string {
	return 'rgba(0, 123, 255,1)';
}

export function getTrendColorBlueGradient2(): string {
	return 'rgba(0, 123, 255,.15)';
}

export function getTrendColorOrange(): string {
	return "#FFA500";
}

export function getTrendColorOrangeGradient1(): string {
	return 'rgba(255, 165, 0,1)';
}

export function getTrendColorOrangeGradient2(): string {
	return 'rgba(255, 165, 0,.15)';
}

export function getTrendColorPurple(): string {
	return "#800080";
}

export function getTrendColorPurpleGradient1(): string {
	return 'rgba(128, 0, 128,1)';
}

export function getTrendColorPurpleGradient2(): string {
	return 'rgba(128, 0, 128,.15)';
}

// New getTrendColorGradient method
export function getTrendColorGradient(colorName: string, gradientNumber: 1 | 2, ctx: CanvasRenderingContext2D | null): CanvasGradient | string {
	if (!ctx) return ''; // Handle the case where ctx is null

	let gradientStart: string, gradientEnd: string;

	switch (colorName) {
		case "green":
			gradientStart = getTrendColorGreenGradient1();
			gradientEnd = getTrendColorGreenGradient2();
			break;
		case "red":
			gradientStart = getTrendColorRedGradient1();
			gradientEnd = getTrendColorRedGradient2();
			break;
		case "blue":
			gradientStart = getTrendColorBlueGradient1();
			gradientEnd = getTrendColorBlueGradient2();
			break;
		case "orange":
			gradientStart = getTrendColorOrangeGradient1();
			gradientEnd = getTrendColorOrangeGradient2();
			break;
		case "purple":
			gradientStart = getTrendColorPurpleGradient1();
			gradientEnd = getTrendColorPurpleGradient2();
			break;
		default:
			gradientStart = 'rgba(0, 0, 0, 1)'; // Default to black gradient
			gradientEnd = 'rgba(0, 0, 0, 0)';
	}

	const gradient = ctx.createLinearGradient(0, 0, 0, 400);
	gradient.addColorStop(0, gradientStart);
	gradient.addColorStop(1, gradientEnd);
	return gradient;
}
// Updated getTrendColor method
export function getTrendColor(colorName: string): string {
	switch (colorName.toLowerCase()) {
		case "green":
			return getTrendColorGreen();
		case "red":
			return getTrendColorRed();
		case "blue":
			return getTrendColorBlue();
		case "orange":
			return getTrendColorOrange();
		case "purple":
			return getTrendColorPurple();
		case "grey":
			return getTrendColorGrey();
		default:
			return "#000000"; // Default to black
	}
}
